import { useMemo } from "react";

import { useSelector } from "react-redux";

import {
    selectConferenceSnapshotActiveParticipants,
    selectConferenceSnapshotSelf,
} from "Services/state/conferences/ConferenceSnapshotSelectors";
import { CALL_STATUS_EVENT } from "Types/CallStatusEvent";
export type UseBarActionsStateResult = {
    availableActions: {
        disableIndependentActions: boolean;
        disableActions: boolean;
    };
};

export const useBarActionsState = (): UseBarActionsStateResult => {
    const { callSid: agentCallSid } = useSelector(selectConferenceSnapshotSelf) || {};
    const activeParticipants = useSelector(selectConferenceSnapshotActiveParticipants);

    const availableActions = useMemo(() => {
        const result = {
            disableIndependentActions: false,
            disableActions: false,
        };
        if (!activeParticipants || activeParticipants.length === 0) {
            return result;
        }

        const participantsJoined = activeParticipants.some(({ status }) => status == CALL_STATUS_EVENT.IN_PROGRESS);
        result.disableActions = !participantsJoined && !agentCallSid;

        result.disableIndependentActions = activeParticipants.length >= 2;

        return result;
    }, [activeParticipants, agentCallSid]);

    return {
        availableActions,
    };
};
